import React from 'react';
import { useHintStore } from '../../stores/hintStore';
import { SmartHint } from './SmartHint';

export const SmartHintContainer: React.FC = () => {
  const { currentHint, closeHint } = useHintStore();

  if (!currentHint) {
    return null;
  }

  return <SmartHint hint={currentHint} onClose={closeHint} />;
};